/**
 * Builds a hidden POST form for SSO flows (e.g. postMessage SSO_SUBMIT).
 * Does not attach or submit the form; caller is responsible for that.
 *
 * @param {string} action - Raw POST target URL (validated and normalized here; callers need not pre-call normalizeSsoActionUrl)
 * @param {Object.<string, string>} [fields] - Hidden input name/value pairs
 * @returns {HTMLFormElement}
 */
export const normalizeSsoActionUrl = (action) => {
    if (typeof action !== 'string' || action.trim() === '') {
        throw new Error('SSO action URL must be a non-empty string');
    }

    let parsedActionUrl;
    try {
        parsedActionUrl = new URL(action);
    } catch {
        throw new Error('SSO action URL must be a well-formed absolute URL');
    }

    const protocol = parsedActionUrl.protocol.toLowerCase();

    if (protocol !== 'http:' && protocol !== 'https:') {
        throw new Error('SSO action URL must use http or https');
    }

    return parsedActionUrl.href;
};

export const buildSsoPostForm = (action, fields) => {
    const normalizedAction = normalizeSsoActionUrl(action);
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = normalizedAction;
    form.style.display = 'none';

    Object.keys(fields || {}).forEach((key) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = fields[key];
        form.appendChild(input);
    });

    return form;
};
